
import {markRaw} from 'vue'
import PulseButton from '../pulse-button.vue'
import {PulseSearch} from 'components/pulse'
import {TRACKER_TYPES} from 'consts/ttypes'

export default {
  components: {PulseSearch, PulseButton},
  props: {
    loading: {type: Boolean, required: false},
    typeCounts: {type: Object, required: true},
  },
  emits: ['update-filters'],
  data() {
    return {
      search: '',
      type: undefined,
      
      tracker_types: markRaw(TRACKER_TYPES)
    }
  },
  computed: {
    filters() {
      return {
        search: this.search,
        types: this.type ? [this.type] : []
      }
    }
  },
  watch: {
    filters(){
      this.$emit('update-filters', this.filters)
    },
  },
  methods: {
    clearAll() {
      this.search = ''
      this.type = undefined
    },
  }
}

